import request from '@/utils/request'
let appList = []
const apps = [] // 去nacos 配置列表share-bff 配
const initApp = async () => {
  if (!appList.length) {
    const res = await request({
      url: '/api/share-bff/micro-services/query-app-list',
      method: 'get'
    })
    appList = res.data
  }
  apps.splice(0)
  appList.forEach((item) => {
    const { name, title, port } = item
    const path = `/${name}/`
    let host = `${window.location.origin}${path}`
    if (process.env.NODE_ENV === 'development') {
      host = `${window.location.protocol}//${window.location.hostname}:${port}`
    }
    if (process.env.VUE_APP_DEVELOPMENT_QIANKUN_HOST) {
      host = `${process.env.VUE_APP_DEVELOPMENT_QIANKUN_HOST}${path}`
    }
    apps.push({
      name,
      title,
      host
    })
  })
}
export {
  appList
}

export async function appConfigs () {
  await initApp()
  const token = sessionStorage.getItem('SESSION') || localStorage.getItem('SESSION')
  const userCode = sessionStorage.getItem('userCode')
  const userId = sessionStorage.getItem('userId')
  const container = '#app-container'
  const activeRuleRouter = process.env.VUE_APP_NAME + '/app-center/main/'
  const map = {}
  apps.forEach((app) => {
    map[app.name] = {
      name: app.name,
      entry: app.host,
      container: container + '-' + app.name,
      activeRule: '/pba/app-center/main/' + app.name + '/',
      props: {
        userCode: userCode,
        userId: userId,
        token: token,
        routerBase: activeRuleRouter + app.name + '/'
      }
    }
  })
  return map
}

export async function getAppConfigs () {
  const map = await appConfigs()
  return map
}

export function getApp (name) {
  apps.forEach((app) => {
    if (app.name === name) {
      return app
    }
  })
}

export function getAppPath (systemCode, resourcePath) {
  return '/app-center/main/' + systemCode + resourcePath
}
